// Generated file - do not change manually!
/**
 * Different types of Button.
 */
export var ButtonDesign;
(function (ButtonDesign) {
    /**
     * attention type
     */
    ButtonDesign["Attention"] = "Attention";
    /**
     * default type (no special styling)
     */
    ButtonDesign["Default"] = "Default";
    /**
     * emphasized type
     */
    ButtonDesign["Emphasized"] = "Emphasized";
    /**
     * reject style (red button)
     */
    ButtonDesign["Negative"] = "Negative";
    /**
     * accept type (green button)
     */
    ButtonDesign["Positive"] = "Positive";
    /**
     * transparent type
     */
    ButtonDesign["Transparent"] = "Transparent";
})(ButtonDesign || (ButtonDesign = {}));
